<template>
  <v-content>
    <v-container class="fill-height">
      <v-row>
        <v-row justify="center">
          <v-col
            cols="12"
            md="8"
            class="text-center"
          >
            <v-img
              height="100"
              :src="require('@/assets/logo_mini_2.png')"
              contain
            />
            <v-card>
              <v-toolbar flat>
                <v-spacer />
                <v-toolbar-title>{{ $t('maintenance.maintenance') }}</v-toolbar-title>
                <v-spacer />
              </v-toolbar>
              <v-img
                height="250"
                :src="require('@/assets/maintenance.png')"
                contain
              />
              <v-card-text style="font-size: 18px;">
                {{ $t('maintenance.information') }}
              </v-card-text>
              <v-card-actions>
                <v-spacer />
                <v-btn
                  class="retry-btn"
                  :loading="loading"
                  large
                  rounded
                  @click="checkMaintenance"
                >
                  {{ $t('maintenance.retry') }}
                </v-btn>
                <v-spacer />
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-row>
    </v-container>
  </v-content>
</template>

<script>
  export default {
    name: 'Maintenance',
    data () {
      return {
        loading: false,
      }
    },
    methods: {
      checkMaintenance () {
        this.loading = true
        this.$store.dispatch('checkApiAccess')
          .then(() => {
            this.loading = false
          })
          .catch(() => {
            this.loading = false
          })
      },
    },
  }
</script>

<style>
.retry-btn.theme--light {
  color: white!important;
  background: linear-gradient(to left, #8743FF, #63BBE9);
}
.retry-btn.theme--dark {
  color: white;
  background: linear-gradient(to left, rgb(108, 23, 253), rgb(16, 138, 204));
}
</style>
